var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loading-container" }, [
    _c("div", { staticClass: "loading-bar" }, [
      _c("i", { staticClass: "kb-logo" }),
      _c(
        "svg",
        {
          class: [_vm.boxRotate ? "box-rotate" : ""],
          attrs: { width: "60", height: "60", viewBox: "0 0 60 60" }
        },
        [
          _c("defs", [
            _c("path", {
              attrs: {
                d:
                  "M166 45h28c8.837 0 16 7.163 16 16v28c0 8.837-7.163 16-16 16h-28c-8.837 0-16-7.163-16-16V61c0-8.837 7.163-16 16-16z",
                id: "a"
              }
            })
          ]),
          _c("use", {
            attrs: {
              fill: "#FFD719",
              transform: "rotate(90 127.5 -22.5)",
              "xlink:href": "#a",
              "fill-rule": "evenodd"
            }
          })
        ]
      ),
      _c("div", { staticClass: "box-back" })
    ]),
    _c("p", { staticClass: "loading-text" }, [_vm._v("KB Global")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }